function readBool(key: string): boolean {
  const raw = import.meta.env[key] as string | undefined;
  return raw === '1' || raw === 'true';
}

function readString(key: string): string | undefined {
  const raw = import.meta.env[key] as string | undefined;
  return raw && raw.length > 0 ? raw : undefined;
}

export const MOCK_BEHAVIOR = {
  noCard: () => readBool('VITE_SIGNING_SIM_NO_CARD'),
  pinRejects: () => readString('VITE_SIGNING_SIM_PIN_REJECTS'),
  /** When set, a Windows strong-key password equal to this value is rejected. */
  keyPasswordRejects: () => readString('VITE_SIGNING_SIM_KEY_PASSWORD_REJECTS'),
  maxPinAttempts: 3,
  maxKeyAttempts: 3,
  signLatencyMs: 600,
  verifyLatencyMs: 400,
};
